import { motion } from "framer-motion";
import { Cctv, Network, Fingerprint, BellRing, Cpu, MonitorDot, ChevronRight } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
  { icon: Cctv, label: "CCTV" },
  { icon: Network, label: "Redes" },
  { icon: Fingerprint, label: "Control de acceso" },
  { icon: BellRing, label: "Alarmas" },
  { icon: Cpu, label: "Automatización" },
  { icon: MonitorDot, label: "Monitoreo" },
];

export const IntegrationFlow = () => (
  <section id="tecnologia" data-testid="integration-section" className="noise relative overflow-hidden bg-glg-black py-24 sm:py-32">
    <div className="absolute inset-0 grid-lines opacity-20" />
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[28rem] w-[28rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-glg-blue/10 blur-[150px]" />

    <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
      <div className="mx-auto mb-16 max-w-3xl text-center">
        <Reveal><p className="text-xs font-semibold uppercase tracking-[0.3em] text-glg-blue">Tecnología GLG</p></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight tracking-tight text-white sm:text-5xl">
            Una sola empresa para integrar toda tu infraestructura tecnológica
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-white/55 sm:text-base">
            No solo instalamos equipos: conectamos cada sistema para que trabajen juntos como una solución completa.
          </p>
        </Reveal>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div key={s.label} className="flex items-center gap-3 sm:gap-4">
              <motion.div
                data-testid={`flow-step-${i}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.45, delay: i * 0.08 }}
                className="group flex w-28 flex-col items-center gap-3 rounded-2xl border border-white/10 bg-glg-surface/60 p-5 backdrop-blur-sm transition-colors duration-300 hover:border-glg-blue/50 sm:w-32"
              >
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-glg-blue/10 transition-colors group-hover:bg-glg-blue/20">
                  <Icon className="h-6 w-6 text-glg-blue" />
                </span>
                <span className="text-center text-xs font-medium leading-tight text-white/80">{s.label}</span>
              </motion.div>
              {i < STEPS.length - 1 && (
                <ChevronRight className="hidden h-5 w-5 shrink-0 text-white/25 sm:block" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
